import { ComboField } from '@components/Fields/ComboField';
import { CompetenciaField } from '@components/Fields/CompetenciaField';
import { DocumentoField } from '@components/Fields/DocumentoField';
import { IntegerField } from '@components/Fields/IntegerField';
import { StringField } from '@components/Fields/StringField';
import { FixedFilterPanel } from '@components/FixedFilterPanel';
import { GridItem } from '@components/GridItem';
import { HorizontalGrid } from '@components/HorizontalGrid';
import { IFilter } from '@hooks/useFilter';
import { Divider, MenuItem } from '@material-ui/core';
import { EnumEmpresa, IComboEmpresa } from '@model/Empresa';
import { faturaTipos } from '@model/Fatura';
import { EnumFaturaStatus, IComboFaturaStatus } from '@model/FaturaStatus';
import { IComboRemetenteWhatsapp } from '@model/RemetenteWhatsapp';
import { IFaturaFilter } from '@services/FaturaService';
import React from 'react';

export type FaturaFilterProps = {
    filter: IFilter<IFaturaFilter>
    isLoading: boolean
    empresaCombo: IComboEmpresa
    faturaStatusCombo: IComboFaturaStatus
    remetenteWhatsappCombo: IComboRemetenteWhatsapp
}

export function FaturaFilter ({ filter, isLoading, empresaCombo, faturaStatusCombo, remetenteWhatsappCombo }: FaturaFilterProps) {
    const handleReset = React.useCallback(() => {
        filter.resetFilter();
    }, [filter]);

    return (
        <FixedFilterPanel
            onSearch={filter.handleFilterRequest}
            onClear={handleReset}
            disabled={isLoading}
        >
            <HorizontalGrid spacing={1}>
                <GridItem xs={1}>
                    <IntegerField
                        field={filter.fields.faturaId}
                        label="ID Fatura"
                        onEnter={filter.handleFilterRequest}
                        fullWidth
                        disabled={isLoading}
                        InputLabelProps={{
                            shrink: true
                        }}
                    />
                </GridItem>

                <GridItem xs={3}>
                    <StringField
                        field={filter.fields.clienteNome}
                        label="Nome do Cliente"
                        onEnter={filter.handleFilterRequest}
                        fullWidth
                        disabled={isLoading}
                        InputLabelProps={{
                            shrink: true
                        }}
                    />
                </GridItem>

                <GridItem xs={2}>
                    <DocumentoField
                        maskType="both"
                        field={filter.fields.clienteCpf}
                        onEnter={filter.handleFilterRequest}
                        fullWidth
                        dynamicLabels={{
                            cpf: "CPF do Cliente",
                            cnpj: "CNPJ do Cliente"
                        }}
                        disabled={isLoading}
                        InputLabelProps={{
                            shrink: true
                        }}
                    />
                </GridItem>

                <GridItem xs={2}>
                    <ComboField
                        field={filter.fields.clienteRemetenteWhatsapp}
                        label="Remetente Whatsapp"
                        onEnter={filter.handleFilterRequest}
                        fullWidth
                        disabled={isLoading}
                        InputLabelProps={{
                            shrink: true
                        }}
                    >
                        <MenuItem key={0} value={0}>Todos</MenuItem>
                        {
                            remetenteWhatsappCombo.createOptionsWithNumero()
                        }
                    </ComboField>
                </GridItem>

                <GridItem xs={2}>
                    <CompetenciaField
                        field={filter.fields.competencia}
                        label="Competência"
                        onEnter={filter.handleFilterRequest}
                        fullWidth
                        disabled={isLoading}
                        InputLabelProps={{
                            shrink: true
                        }}
                    />
                </GridItem>

                <GridItem xs={2}>
                    <ComboField
                        field={filter.fields.empresaId}
                        label="Empresa"
                        onEnter={filter.handleFilterRequest}
                        fullWidth
                        disabled={isLoading}
                        InputLabelProps={{
                            shrink: true
                        }}
                    >
                        <MenuItem key={0} value={EnumEmpresa.None}>Todas</MenuItem>
                        <Divider />
                        {
                            empresaCombo.createOptions()
                        }
                    </ComboField>
                </GridItem>

                <GridItem xs={2}>
                    <ComboField
                        field={filter.fields.faturaStatusId}
                        label="Status da Fatura"
                        onEnter={filter.handleFilterRequest}
                        fullWidth
                        disabled={isLoading}
                        InputLabelProps={{
                            shrink: true
                        }}
                    >
                        <MenuItem key={0} value={EnumFaturaStatus.None}>Todos</MenuItem>
                        <Divider />
                        {
                            faturaStatusCombo.createOptions()
                        }
                    </ComboField>
                </GridItem>

                <GridItem xs={2}>
                    <ComboField
                        field={filter.fields.tipo}
                        label="Tipo da Fatura"
                        onEnter={filter.handleFilterRequest}
                        fullWidth
                        disabled={isLoading}
                        InputLabelProps={{
                            shrink: true
                        }}
                    >
                        <MenuItem key="0" value="">Todos</MenuItem>
                        <Divider />
                        {
                            faturaTipos.map(v => <MenuItem key={v} value={v}>{v}</MenuItem>)
                        }
                    </ComboField>
                </GridItem>
            </HorizontalGrid>
        </FixedFilterPanel>
    )
}